import { NotificationService } from "#gen/notifications/v2/notifications_pb.js";
import { type NotificationSchema } from "#gen/notifications/v2/notifications_pb.js";
import { createClient, type ClientOptions } from "#lib/api/api.js";
import { handleError } from "#lib/api/error.js";
import { PUBLIC_URLS } from "#lib/url.js";
import type { MessageInitShape } from "@bufbuild/protobuf";
import type { Client } from "@connectrpc/connect";

export class NotificationClient {
	private client: Client<typeof NotificationService>;

	constructor(options?: () => ClientOptions) {
		this.client = createClient(PUBLIC_URLS.notifications || "/", NotificationService, options);
	}

	async notify(notification: MessageInitShape<typeof NotificationSchema>): Promise<void> {
		try {
			await this.client.notify({ notification });
		} catch (e) {
			throw handleError(e);
		}
	}

	async testNotify(notification: MessageInitShape<typeof NotificationSchema>): Promise<void> {
		try {
			await this.client.testNotify({ notification });
		} catch (e) {
			throw handleError(e);
		}
	}
}
